<ng-container>
  <a *ngIf="lang == 'ar' ;else ArabicLanguage" style="color: rgb(182 142 39);font-size: 20px;font-weight: bold;"
    href="javascript:;" (click)="setLanguageWithRefresh('en')" >
    <span >
            <i class="fas fa-times"></i>
      <!-- <img src="assets/img/home-one/En.jpg"  style="border-radius: 5px;"/> -->
       English
    </span>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <path d="M12 2C6.477 2 2 6.477 2 12c0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zm7.938 8h-3.447a15.945 15.945 0 0 0-1.365-4.598A8.006 8.006 0 0 1 19.938 10zM12 4c.978 1.25 1.747 3.095 2.136 5H9.864C10.253 7.095 11.022 5.25 12 4zM4.062 10a8.006 8.006 0 0 1 4.812-6.598A15.945 15.945 0 0 0 7.51 10H4.062zm0 4h3.447a15.945 15.945 0 0 0 1.365 4.598A8.006 8.006 0 0 1 4.062 14zM12 20c-.978-1.25-1.747-3.095-2.136-5h4.272C13.747 16.905 12.978 18.75 12 20zm1.934-7H10.066a13.97 13.97 0 0 1 0-2h3.868a13.97 13.97 0 0 1 0 2zm1.559 5.598A15.945 15.945 0 0 0 16.49 14h3.448a8.006 8.006 0 0 1-4.445 5.598z"/>
</svg>

  </a>

  <ng-template #ArabicLanguage>
    <a style="color: rgb(182 142 39);font-size: 20px;font-weight: bold;" href="javascript:;"
      (click)="setLanguageWithRefresh('ar')" >
     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <path d="M12 2C6.477 2 2 6.477 2 12c0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zm7.938 8h-3.447a15.945 15.945 0 0 0-1.365-4.598A8.006 8.006 0 0 1 19.938 10zM12 4c.978 1.25 1.747 3.095 2.136 5H9.864C10.253 7.095 11.022 5.25 12 4zM4.062 10a8.006 8.006 0 0 1 4.812-6.598A15.945 15.945 0 0 0 7.51 10H4.062zm0 4h3.447a15.945 15.945 0 0 0 1.365 4.598A8.006 8.006 0 0 1 4.062 14zM12 20c-.978-1.25-1.747-3.095-2.136-5h4.272C13.747 16.905 12.978 18.75 12 20zm1.934-7H10.066a13.97 13.97 0 0 1 0-2h3.868a13.97 13.97 0 0 1 0 2zm1.559 5.598A15.945 15.945 0 0 0 16.49 14h3.448a8.006 8.006 0 0 1-4.445 5.598z"/>
</svg>

      <span >
        <!-- <img src="assets/img/home-one/Ar.jpg"   style="border-radius: 5px;" /> -->
         العربية
      </span>
    </a>
  </ng-template>
</ng-container>